/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonIdDocuments200,
  GetApiV1PersonIdDocuments401,
  GetApiV1PersonIdDocuments404,
  GetApiV1PersonIdDocuments500,
  GetApiV1PersonIdDocumentsPathParams,
  GetApiV1PersonIdDocumentsQueryResponse,
} from "../../types/personRegisterController/GetApiV1PersonIdDocuments.ts";
import { personDocumentDataViewModelSchema } from "../personDocumentDataViewModelSchema.ts";

export const getApiV1PersonIdDocumentsPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1PersonIdDocumentsPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonIdDocuments200Schema = z.lazy(
  () => personDocumentDataViewModelSchema,
) as unknown as ToZod<GetApiV1PersonIdDocuments200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonIdDocuments401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdDocuments401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1PersonIdDocuments404Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdDocuments404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonIdDocuments500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdDocuments500>;

export const getApiV1PersonIdDocumentsQueryResponseSchema = z.lazy(
  () => getApiV1PersonIdDocuments200Schema,
) as unknown as ToZod<GetApiV1PersonIdDocumentsQueryResponse>;
